import { render, staticRenderFns } from "./WidgetImage.vue?vue&type=template&id=4aec0cb5"
import script from "./WidgetImage.vue?vue&type=script&lang=js"
export * from "./WidgetImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports